module.exports = {"update-required-data":{"text":"Antes de continuar, por favor, rellene los siguientes datos:","contact-chat":"Si no conoce su número de empleado, por favor contacte con el chat de asistencia técnica para recibir ayuda.","save":"Actualizar datos","messages":{"dni-already-exists":"Ya existe un usuario registrado con ese documento de identidad","user-is-underage":"Debe de ser mayor de edad para poder registrarse"}}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/es/public/views/account/update-required-data.json
// module id = 323
// module chunks = 116